import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Typography,
  Card,
  Alert
} from '@mui/joy';
import { useAuth } from '../context/AuthContext';
import LocusLogo from '../components/LocusLogo';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/stock');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.body',
        padding: 2
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 400 }}>
        <LocusLogo width={300} height={100} sx={{ width: '100%', maxWidth: 300, mx: 'auto', mb: 1.5 }} />
        <Typography
          level="body-sm"
          fontWeight="lg"
          sx={{ textAlign: 'center', color: 'primary.500', mb: 2 }}
        >
          Sign in to Stock Management
        </Typography>

        {error && (
          <Alert color="danger" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
            <Typography level="body-xs" sx={{ mt: 0.5, textAlign: 'right' }}>
              <Link to="/forgot-password" style={{ color: 'var(--joy-palette-primary-500)' }}>
                Forgot password?
              </Link>
            </Typography>
          </FormControl>

          <Button type="submit" loading={loading} fullWidth color="primary" sx={{ mb: 2 }}>
            Login
          </Button>
        </form>
      </Card>
    </Box>
  );
};

export default Login;
